<template>
    <div v-if="storeSearchResults.length > 0" class="suggest-result">
        <h3>{{ __('frontend_js.search.stores') }}</h3>
        <ul>
            <li v-for="store in storeSearchResults" :key="store.id">
                <a :href="store.slug" class="hover-remove-underline text-dark">{{ store.title }} </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        storeSearchResults: {
            type: Array,
        },
    },
};
</script>

<style>
</style>
